import { render, staticRenderFns } from "./HtmlTagFactory.vue?vue&type=template&id=50dd5369&"
import script from "./HtmlTagFactory.vue?vue&type=script&lang=js&"
export * from "./HtmlTagFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports